// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Managers
//import ColorManager from '../styles/ColorManager';

// Components
//import StatCard from '../components/StatCard';
import Grid from '@material-ui/core/Grid';
import DataTable from '../components/DataTable';
import Typography from '@material-ui/core/Typography';
//import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

interface State {
  cardFilter: any;
  cards: any;
}

interface Props {
  location: any;
  navigation: any;
}

/**
 * @description Borrows View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class Team extends React.Component<Props, State> {

  /**
   * Creates an instance of Borrows.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);
    this.state = {
      cardFilter: {
        name: "status",
        value: ""
      },
      cards: []
    };
  }

  updateCardFilter = (value: any) => {
    return (): void => {
      this.setState({
        cardFilter: {
          name: "status",
          value: value
        }
      });
    };
  }

  componentDidMount() {
    document.title = "Gigon SA | Equipe";

    if (this.props.location.state) {
      this.setState({
        cardFilter: this.props.location.state.cardFilter
      });
    }
  }

  /**
   * @description Render the BorrowsView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const columns = [
      { id: 'id', numeric: true, disablePadding: false, label: 'Id' },
      { id: 'lastname', numeric: false, disablePadding: false, label: 'Nom' },
      { id: 'firstname', numeric: false, disablePadding: false, label: 'Prénom' },
      { id: 'title', numeric: false, disablePadding: false, label: 'Titre' },
      { id: 'phone', numeric: false, disablePadding: false, label: 'Téléphone' },
      { id: 'email', numeric: false, disablePadding: false, label: 'Email' },
      { id: 'order', numeric: false, disablePadding: false, label: 'Ordre' }
    ];
    const actions = [
      "close",
      "update",
      "delete"
    ];

    return (
      <div>
        <Grid container={true} spacing={24}>
          <Grid item={true} xs={12}>
            <Typography variant="headline" gutterBottom={true}>Equipe</Typography>
          </Grid>
          </Grid>

        <DataTable title="Enregistrement de la table Equipe" actions={actions} columns={columns} rows="team" apiPath="team"
          isPossibleToFilter={false} selectableFilter={this.state.cardFilter} urlPath="Equipe" />
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Team.tsx